<template>
	<div>
		<div>
			<div v-if="!loading" class="answer-block">
				<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">When will my book ship?</h1>

				<div v-if="condition !== 'exchange'">
					<p class="h-text-2" v-if="isMaxInPast()">
						We’re sorry, it appears your book may be experiencing a delay, and it has passed the latest date we expected to ship by
						<strong>({{ format(max_delivery_date) }})</strong>.
						Please email us so we can look into it
					</p>

					<p class="h-text-2" v-else-if="isAvgInPast()">
						We’re sorry, it appears your book may be experiencing a delay, though it has not yet passed the maximum estimated ship date
						<strong>({{ format(max_delivery_date) }})</strong>. Please email us so we can look into it
					</p>

					<p class="h-text-2" v-else-if="isMinInPast()">
						We’re sorry, it appears your book may be experiencing a delay, though it has not yet passed the maximum estimated ship date
						<strong>({{ format(max_delivery_date) }})</strong>. Please email us so we can look into it
					</p>

					<p class="h-text-2" v-else>
						Though your book hasn't shipped yet, we do see it hasn't yet passed out minimum expected ship date, which is
						<strong>{{ format(min_delivery_date) }}</strong>. Please check back here once that date has passed for more options.
					</p>

					<email-form
							caption="Email us"
							subject="The expected ship date has passed"
							:body="email_body"
							on-success-url="/help?#/submitted"
							on-error-url="/help?#/that_error"
							edit-body
							:payload="{ order_line_id }"
							destination-key="cs"
							v-if="isEmailFormToShow"
					></email-form>

				</div>

				<div v-else>
					<p class="h-text-2" v-if="isMaxInPast()">
						We’re sorry, it appears your book may be experiencing a delay, and it has passed the latest date we expected to ship by
						<strong>({{ format(max_delivery_date) }})</strong>.
						Please <a :href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.id)}#lastmessage`">message your
						seller</a> so they can review
					</p>

					<p class="h-text-2" v-else-if="isAvgInPast()">
						We’re sorry, it appears your book may be experiencing a delay, though it has not yet passed the maximum estimated ship date
						<strong>({{ format(max_delivery_date) }})</strong>.
						Please <a :href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.id)}#lastmessage`">message your
						seller</a> so they can review
					</p>

					<p class="h-text-2" v-else-if="isMinInPast()">
						We’re sorry, it appears your book may be experiencing a delay, though it has not yet passed the maximum estimated ship date
						<strong>({{ format(max_delivery_date) }})</strong>.
						Please <a :href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.id)}#lastmessage`">message your
						seller</a> so they can review
					</p>

					<p class="h-text-2" v-else>
						Though your book hasn't shipped yet, we do see it hasn't yet passed out minimum expected ship date, which is
						<strong>{{ format(min_delivery_date) }}</strong>. Please check back here once that date has passed for more options.
					</p>

					<div v-if="isEmailFormToShow">
						<p v-if="!spoke_to_seller">
							<v-btn @click="spoke_to_seller = true">I already messaged the seller and got no response</v-btn>
						</p>

						<email-form
								caption="Contact Us"
								v-if="spoke_to_seller"
								subject="The expected marketplace ship date has passed"
								body="I already messaged the seller and got no response"
								on-success-url="/help?#/submitted"
								edit-body
								:payload="{ order_line_id }"
								destination-key="cs"
						></email-form>
					</div>
				</div>

			</div>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../../components/BaseNavLinks';
	import Axios from 'axios';
	import moment from 'moment';
	import EmailForm from './../../../components/EmailForm';
	import {formatDate} from './../../../../helpers';

	export default {
		name: "WhenWillMyBookShip",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				loading: false,
				min_delivery_date: null,
				max_delivery_date: null,
				avg_delivery_date: null,
				order_id: null,
				condition: null,
				spoke_to_seller: false,
				order_line_id: null,
				isbn: null,
			}
		},

		methods: {
			isMinInPast() {
				return moment.utc(this.min_delivery_date + ' 23:59:59', 'YYYY-MM-DD HH:mm:ss') < moment();
			},

			isMaxInPast() {
				return moment.utc(this.max_delivery_date + ' 23:59:59', 'YYYY-MM-DD HH:mm:ss') < moment();
			},

			isAvgInPast() {
				return moment.utc(this.avg_delivery_date + ' 23:59:59', 'YYYY-MM-DD HH:mm:ss') < moment();
			},

			format(x) {
				return formatDate(x);
			}
		},

		computed: {
			isEmailFormToShow() {
				return this.isMinInPast();
			},

			email_body() {
				return `I have not received my item, and the expected ship date has passed, can you look into it and tell me when my book will ship?`;
			},
		},

		mounted() {
			const self = this;
			self.loading = true;

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_estimated_ship_date/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						let d = response['data']['data'];
						self.min_delivery_date = d['min_delivery_date'];
						self.max_delivery_date = d['max_delivery_date'];
						self.avg_delivery_date = d['avg_delivery_date'];
						self.isbn = d['isbn'];
						self.order_id = d['order_id'];
						self.condition = d['condition'];
						self.order_line_id = parseInt(self.$route.params.id);
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},
	}
</script>

<style scoped>

</style>